export default "__VITE_ASSET__a2d403da__"